import { jsx, jsxs } from "react/jsx-runtime";
import React__default, { useCallback } from "react";
import Typography from "../Typography/Typography.js";
import classnames from "../../utils/classnames.js";
function pairArray(array) {
  const pairs = [];
  array.forEach((item, i) => {
    if (i % 2 === 0) {
      const pair = [item, array[i + 1]].filter(Boolean);
      pairs.push(pair);
    }
  });
  return pairs;
}
const DealerInfoSchedule = ({
  items,
  className,
  renderCell = (_, element) => element,
  onPhoneClick
}) => {
  const pairItems = pairArray(items);
  const handlePhoneClick = useCallback(
    (e) => {
      var _a, _b;
      const phone = (_b = (_a = e == null ? void 0 : e.currentTarget) == null ? void 0 : _a.dataset) == null ? void 0 : _b.phone;
      if (phone) {
        onPhoneClick == null ? void 0 : onPhoneClick(phone);
      }
    },
    [onPhoneClick]
  );
  return /* @__PURE__ */ jsx(
    "table",
    {
      className: classnames(
        ["perxis-auto-dealer-info-schedule", { "perxis-auto-dealer-info-schedule--multi": items.length > 1 }],
        className
      ),
      children: /* @__PURE__ */ jsx("tbody", { children: pairItems.map(([firstItem, secondItem]) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const isShowPhonesRow = !!((_a = firstItem.phones) == null ? void 0 : _a.length) || !!((_b = secondItem == null ? void 0 : secondItem.phones) == null ? void 0 : _b.length);
        const isShowSchedulesRow = !!((_c = firstItem.schedules) == null ? void 0 : _c.length) || !!((_d = secondItem == null ? void 0 : secondItem.schedules) == null ? void 0 : _d.length);
        return /* @__PURE__ */ jsxs(React__default.Fragment, { children: [
          /* @__PURE__ */ jsxs("tr", { children: [
            (firstItem == null ? void 0 : firstItem.label) ? renderCell(
              { item: firstItem, type: "label" },
              /* @__PURE__ */ jsx("th", { children: /* @__PURE__ */ jsxs(
                Typography.Text,
                {
                  color: "dark-light",
                  level: "small",
                  className: classnames("perxis-auto-dealer-info-schedule__label"),
                  children: [
                    firstItem.label,
                    ":"
                  ]
                }
              ) })
            ) : /* @__PURE__ */ jsx("th", {}),
            (secondItem == null ? void 0 : secondItem.label) ? renderCell(
              { item: secondItem, type: "label" },
              /* @__PURE__ */ jsx("th", { children: /* @__PURE__ */ jsxs(
                Typography.Text,
                {
                  color: "dark-light",
                  level: "small",
                  className: classnames("perxis-auto-dealer-info-schedule__label"),
                  children: [
                    secondItem.label,
                    ":"
                  ]
                }
              ) })
            ) : /* @__PURE__ */ jsx("th", {})
          ] }),
          isShowPhonesRow && /* @__PURE__ */ jsxs("tr", { children: [
            ((_e = firstItem.phones) == null ? void 0 : _e.length) ? renderCell(
              { item: firstItem, type: "phones" },
              /* @__PURE__ */ jsx("td", { children: /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-dealer-info-schedule__container"), children: firstItem.phones.map((phone, i) => /* @__PURE__ */ jsx(
                Typography.Link,
                {
                  href: `tel:${phone}`,
                  level: "small",
                  color: "darkest",
                  "data-phone": phone,
                  onClick: handlePhoneClick,
                  className: classnames("perxis-auto-dealer-info-schedule__phone"),
                  children: phone
                },
                i
              )) }) })
            ) : /* @__PURE__ */ jsx("td", {}),
            ((_f = secondItem == null ? void 0 : secondItem.phones) == null ? void 0 : _f.length) ? renderCell(
              { item: secondItem, type: "phones" },
              /* @__PURE__ */ jsx("td", { children: /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-dealer-info-schedule__container"), children: secondItem.phones.map((phone, i) => /* @__PURE__ */ jsx(
                Typography.Link,
                {
                  href: `tel:${phone}`,
                  level: "small",
                  color: "darkest",
                  "data-phone": phone,
                  onClick: handlePhoneClick,
                  className: classnames("perxis-auto-dealer-info-schedule__phone"),
                  children: phone
                },
                i
              )) }) })
            ) : /* @__PURE__ */ jsx("td", {})
          ] }),
          isShowSchedulesRow && /* @__PURE__ */ jsxs("tr", { children: [
            ((_g = firstItem.schedules) == null ? void 0 : _g.length) ? renderCell(
              { item: firstItem, type: "schedules" },
              /* @__PURE__ */ jsx("td", { children: /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-dealer-info-schedule__container"), children: firstItem.schedules.map((schedule, i) => /* @__PURE__ */ jsx(
                Typography.Text,
                {
                  level: "small",
                  color: "dark",
                  className: classnames("perxis-auto-dealer-info-schedule__timetable"),
                  children: schedule
                },
                i
              )) }) })
            ) : /* @__PURE__ */ jsx("td", {}),
            ((_h = secondItem == null ? void 0 : secondItem.schedules) == null ? void 0 : _h.length) ? renderCell(
              { item: secondItem, type: "schedules" },
              /* @__PURE__ */ jsx("td", { children: /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-dealer-info-schedule__container"), children: secondItem.schedules.map((schedule, i) => /* @__PURE__ */ jsx(
                Typography.Text,
                {
                  level: "small",
                  color: "dark",
                  className: classnames("perxis-auto-dealer-info-schedule__timetable"),
                  children: schedule
                },
                i
              )) }) })
            ) : /* @__PURE__ */ jsx("td", {})
          ] })
        ] }, firstItem.id);
      }) })
    }
  );
};
export {
  DealerInfoSchedule as default
};
//# sourceMappingURL=DealerInfoSchedule.js.map
